<dl class="grid-container">
    <dt
        id="button-wrapper"
        class="g-12 xs:g-6"
    >
        <button
            class="button -blue -sqr"
            type="button"
            aria-label="Logindaten bearbeiten."
            (click)="edit.emit()"
        >
            <i ctrlIcon="pen"></i>
        </button>
    </dt>
    <app-portal-widget-details
        class="g-12 m-24:b"
        heading="E-mail"
        [detail]="customer().mail"
    />
    <app-portal-widget-details
        class="g-12"
        heading="Passwort"
        detail="**********"
    />
</dl>
